// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { jbc as _jbc } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the jbc chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 8899
 * Chain Name: JIBCHAIN L1
 * Default Block Explorer: https://exp-l1.jibchain.net
 * Default RPC URL: https://rpc-l1.jibchain.net
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { jbc } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: jbc,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const jbc = createCommon({
	..._jbc,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
